import { useNavigate } from "react-router-dom";
import CardLogo from "../../../../assets/business/images/payment-tetails-img.png";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getData } from "country-list";
import { ManageBankAccountDetails, GetBankAccountInfo } from "../../services/stripe.servic4e";

const COUNTRIES = getData().sort((a, b) => a.name.localeCompare(b.name));

function ManageBankAccount() {
  const navigate = useNavigate();
  const [country, setCountry] = useState("IE");

  const [loading, setLoading] = useState(true);
  const [disableBtn, setDisableBtn] = useState(false);
  const [bankInfo, setBankInfo] = useState(null);
  const [copied, setCopied] = useState(false);

  const fetchBankInfo = async () => {
    setLoading(true);
    try {
      const response = await GetBankAccountInfo();
      if (response?.success && response?.data) {
        setBankInfo(response.data);
      } else {
        setBankInfo(null);
      }
    } catch (err) {
      console.error("Error loading bank details:", err);
      setBankInfo(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankInfo();
  }, []);

  const configurebankAccount = (e) => {
    if (e) e.preventDefault();
    setDisableBtn(true);
    ManageBankAccountDetails(country)
      .then((response) => {
        if (response?.data?.onboardingUrl) {
          window.location.href = response.data.onboardingUrl;
        } else {
          Swal.fire({
            icon: "error",
            title: "Stripe Connection",
            text: response?.message || "Failed to get Stripe onboarding URL.",
            confirmButtonColor: "#F27438",
          });
          setDisableBtn(false);
        }
      })
      .catch((err) => {
        setDisableBtn(false);
        const errMsg = err?.response?.data?.message || err?.message || "Error connecting to Stripe.";
        if (errMsg.includes("Accounts v1") || errMsg.includes("feat_accounts_v1_support")) {
          Swal.fire({
            icon: "info",
            title: "Enable Stripe Accounts v1",
            html: `
              <p style="font-size: 14px; color: #555; margin-bottom: 12px;">
                Stripe requires enabling <b>Accounts v1 support</b> for Express connected accounts on new platforms.
              </p>
              <p style="font-size: 13px; color: #666; margin-bottom: 16px;">
                In your Stripe Dashboard under <b>Account settings &rarr; Account features and previews</b>, toggle <b>Accounts v1 support</b> on.
              </p>
              <a href="https://dashboard.stripe.com/settings/features/feat_accounts_v1_support" target="_blank" rel="noreferrer" style="display:inline-block; padding: 9px 20px; background: #F27438; color: #fff; border-radius: 6px; text-decoration: none; font-weight: 600;">
                Open Stripe Feature Settings &rarr;
              </a>
            `,
            showConfirmButton: true,
            confirmButtonText: "I've Enabled It",
            confirmButtonColor: "#333",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Stripe Error",
            text: errMsg,
            confirmButtonColor: "#F27438",
          });
        }
      });
  };

  const copyAccountId = () => {
    if (!bankInfo?.accountId) return;
    navigator.clipboard.writeText(bankInfo.accountId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const isConfigured = Boolean(bankInfo?.isConfigured && bankInfo?.accountId);
  const bankAccounts = bankInfo?.bankAccounts || [];

  return (
    <div className="main-content">
      <div className="customer-part">
        <div className="card-box">
          <div className="container section-section" style={{ maxWidth: "860px", margin: "0 auto" }}>
            {/* Header with Title and Refresh Button */}
            <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
              <div>
                <h4 className="h3-headline mb-1" style={{ fontSize: "22px", color: "#111827" }}>
                  Bank Account & Payouts
                </h4>
                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                  Manage your verified bank account and Stripe payout settings.
                </p>
              </div>

              {isConfigured && (
                <button
                  type="button"
                  onClick={fetchBankInfo}
                  disabled={loading}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 16px",
                    backgroundColor: "#FFFFFF",
                    color: "#374151",
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: loading ? "not-allowed" : "pointer",
                    whiteSpace: "nowrap",
                    width: "auto",
                    height: "auto",
                    lineHeight: "normal",
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <i
                    className={`ri-refresh-line ${loading ? "ri-spin" : ""}`}
                    style={{ fontSize: "16px", color: "#F27438", display: "inline-block" }}
                  ></i>
                  <span>Refresh Status</span>
                </button>
              )}
            </div>

            {loading ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "70px 20px",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    width: "42px",
                    height: "42px",
                    color: "#F27438",
                    borderWidth: "3.5px",
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p
                  style={{
                    marginTop: "16px",
                    marginBottom: 0,
                    fontSize: "15px",
                    fontWeight: "500",
                    color: "#6B7280",
                    textAlign: "center",
                  }}
                >
                  Loading your Stripe bank details...
                </p>
              </div>
            ) : !isConfigured ? (
              /* Unlinked State */
              <div className="with-payment text-center py-4">
                <h3 className="h3-headline text-center mt-2">Business Profile Setup</h3>
                <div className="add-payment-details-wrapper text-center mt-3">
                  <div className="content-item">
                    <figure>
                      <img src={CardLogo} alt="Payment details" style={{ maxWidth: "120px" }} />
                    </figure>

                    <figcaption>
                      <h4 className="h2-headline mt-3">Add Payment Details</h4>
                      <p className="subtitle-2 text-muted mt-2 px-md-5">
                        Connect your Stripe Express account to securely receive payouts directly to your bank account.
                      </p>

                      <div className="mt-4 mx-auto text-start" style={{ maxWidth: "320px" }}>
                        <label className="form-label small text-muted" htmlFor="stripe-country">
                          Country of your business / bank account
                        </label>
                        <select
                          id="stripe-country"
                          className="form-select"
                          value={country}
                          onChange={(e) => setCountry(e.target.value)}
                          disabled={disableBtn}
                        >
                          {COUNTRIES.map((c) => (
                            <option key={c.code} value={c.code}>
                              {c.name}
                            </option>
                          ))}
                        </select>
                        <small className="text-muted">This can't be changed after your account is created.</small>
                      </div>

                      <div className="text-center mt-4">
                        <button
                          className="btn btn-oring px-4 py-2"
                          disabled={disableBtn}
                          onClick={configurebankAccount}
                        >
                          {disableBtn ? "Opening Stripe..." : "Link your account with Stripe"}
                        </button>
                      </div>
                    </figcaption>
                  </div>
                </div>
              </div>
            ) : (
              /* Configured State - Clean Single View */
              <div className="with-payment">
                {/* Status Ribbon with Connected Stripe Account ID */}
                <div
                  className="p-3 mb-4 rounded-3 d-flex flex-wrap justify-content-between align-items-center gap-3"
                  style={{
                    backgroundColor: bankInfo.payoutsEnabled ? "#F0FDF4" : "#FFFBEB",
                    border: bankInfo.payoutsEnabled ? "1px solid #BBF7D0" : "1px solid #FDE68A",
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "44px",
                        height: "44px",
                        backgroundColor: bankInfo.payoutsEnabled ? "#DCFCE7" : "#FEF3C7",
                        color: bankInfo.payoutsEnabled ? "#16A34A" : "#D97706",
                        fontSize: "22px",
                        flexShrink: 0,
                      }}
                    >
                      <i className={bankInfo.payoutsEnabled ? "ri-checkbox-circle-fill" : "ri-time-fill"}></i>
                    </div>
                    <div>
                      <div
                        className="fw-bold"
                        style={{ color: bankInfo.payoutsEnabled ? "#15803D" : "#B45309", fontSize: "15px" }}
                      >
                        {bankInfo.payoutsEnabled ? "Payouts Active & Verified" : "Verification in Progress"}
                      </div>
                      <small className="text-muted" style={{ fontSize: "13px" }}>
                        {bankInfo.payoutsEnabled
                          ? "Your bank account is verified and ready to receive automatic payouts."
                          : "Stripe is currently reviewing your account information."}
                      </small>
                    </div>
                  </div>

                  {/* Connected Stripe Account Tag with Copy */}
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="d-flex align-items-center gap-2 px-3 py-1 bg-white border rounded-pill shadow-sm"
                      style={{ fontSize: "12px", color: "#6B7280" }}
                    >
                      <span>Stripe ID:</span>
                      <span className="font-monospace fw-semibold text-dark">{bankInfo.accountId}</span>
                      <button
                        type="button"
                        onClick={copyAccountId}
                        title="Copy Stripe Account ID"
                        style={{
                          background: "none",
                          border: "none",
                          padding: "2px 4px",
                          margin: 0,
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          color: copied ? "#16A34A" : "#6B7280",
                          fontSize: "14px",
                          lineHeight: 1,
                          height: "auto",
                          width: "auto",
                        }}
                      >
                        <i className={copied ? "ri-check-line text-success" : "ri-file-copy-line"}></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Bank Account Section */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold mb-0" style={{ fontSize: "16px", color: "#1F2937" }}>
                      Linked Bank Account
                    </h5>
                    <span className="badge bg-light text-muted border px-2 py-1" style={{ fontSize: "12px" }}>
                      {bankAccounts.length} {bankAccounts.length === 1 ? "Account" : "Accounts"} Linked
                    </span>
                  </div>

                  {bankAccounts.length === 0 ? (
                    <div className="text-center py-5 bg-white border rounded-3 p-4">
                      <i className="ri-bank-line fs-1 text-muted"></i>
                      <h5 className="mt-3">No Bank Accounts Found</h5>
                      <p className="text-muted small">
                        Your Stripe account is connected, but no external payout bank account is linked yet.
                      </p>
                      <button
                        className="btn btn-oring mt-2"
                        onClick={configurebankAccount}
                        disabled={disableBtn}
                      >
                        {disableBtn ? "Opening Stripe..." : "Add Bank Account on Stripe"}
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex flex-column gap-3">
                      {bankAccounts.map((bank, index) => (
                        <div
                          key={bank.id || index}
                          className="card rounded-3 shadow-sm"
                          style={{
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #E5E7EB",
                            overflow: "hidden",
                          }}
                        >
                          {/* Top Bar of Bank Card */}
                          <div
                            className="p-3 d-flex flex-wrap justify-content-between align-items-center gap-2 border-bottom"
                            style={{ backgroundColor: "#FAFAFA" }}
                          >
                            <div className="d-flex align-items-center gap-3">
                              <div
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                  width: "42px",
                                  height: "42px",
                                  backgroundColor: "#FFF3E8",
                                  color: "#F27438",
                                  fontSize: "20px",
                                  flexShrink: 0,
                                }}
                              >
                                <i className="ri-bank-line"></i>
                              </div>
                              <div>
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                  <h6 className="mb-0 fw-bold" style={{ fontSize: "16px", color: "#111827" }}>
                                    {bank.bankName || "Bank Account"}
                                  </h6>
                                  {bank.isDefault && (
                                    <span
                                      className="badge rounded-pill"
                                      style={{
                                        backgroundColor: "#EFF6FF",
                                        color: "#2563EB",
                                        border: "1px solid #BFDBFE",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Default Payout Method
                                    </span>
                                  )}
                                  <span
                                    className="badge rounded-pill"
                                    style={{
                                      backgroundColor: "#F0FDF4",
                                      color: "#16A34A",
                                      border: "1px solid #BBF7D0",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {bank.status === "new" ? "Verified" : bank.status || "Active"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div
                              className="d-flex align-items-center gap-1 text-success"
                              style={{ fontSize: "13px", fontWeight: "600" }}
                            >
                              <i className="ri-checkbox-circle-fill"></i>
                              <span>Ready for Direct Deposits</span>
                            </div>
                          </div>

                          {/* Card Body with Detailed Info */}
                          <div className="p-4">
                            {/* Masked Account Number */}
                            <div className="mb-4">
                              <div
                                className="text-muted small mb-1"
                                style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}
                              >
                                Account Number
                              </div>
                              <div
                                className="font-monospace fw-bold"
                                style={{ fontSize: "22px", letterSpacing: "2px", color: "#1F2937" }}
                              >
                                •••• •••• •••• {bank.last4}
                              </div>
                            </div>

                            {/* Details Grid */}
                            <div className="row g-3 pt-3 border-top">
                              <div className="col-6 col-md-3">
                                <div className="text-muted small" style={{ fontSize: "12px" }}>
                                  Routing Number
                                </div>
                                <div className="fw-semibold text-dark mt-1" style={{ fontSize: "14px" }}>
                                  {bank.routingNumber || "N/A"}
                                </div>
                              </div>

                              <div className="col-6 col-md-3">
                                <div className="text-muted small" style={{ fontSize: "12px" }}>
                                  Currency
                                </div>
                                <div className="fw-semibold text-dark mt-1" style={{ fontSize: "14px" }}>
                                  <span className="badge bg-light text-dark border px-2 py-1">
                                    {(bank.currency || "USD").toUpperCase()}
                                  </span>
                                </div>
                              </div>

                              <div className="col-6 col-md-3">
                                <div className="text-muted small" style={{ fontSize: "12px" }}>
                                  Country
                                </div>
                                <div className="fw-semibold text-dark mt-1" style={{ fontSize: "14px" }}>
                                  {bank.country || "US"}
                                </div>
                              </div>

                              <div className="col-6 col-md-3">
                                <div className="text-muted small" style={{ fontSize: "12px" }}>
                                  Account Type
                                </div>
                                <div className="fw-semibold text-dark mt-1 text-capitalize" style={{ fontSize: "14px" }}>
                                  {bank.accountHolderType || "Checking"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Bottom Actions Card */}
                <div
                  className="p-3 p-md-4 rounded-3 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3"
                  style={{ backgroundColor: "#FAFAFA", border: "1px dashed #D1D5DB" }}
                >
                  <div>
                    <h6 className="fw-bold mb-1" style={{ fontSize: "14px", color: "#111827" }}>
                      Need to update your bank account or payout details?
                    </h6>
                    <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                      You can modify your banking information or payout schedule securely through Stripe Express.
                    </p>
                  </div>

                  <button
                    type="button"
                    onClick={configurebankAccount}
                    disabled={disableBtn}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "10px 22px",
                      backgroundColor: "#F27438",
                      color: "#FFFFFF",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: disableBtn ? "not-allowed" : "pointer",
                      whiteSpace: "nowrap",
                      width: "auto",
                      height: "auto",
                      flexShrink: 0,
                      boxShadow: "0 2px 4px rgba(242, 116, 56, 0.25)",
                    }}
                  >
                    <i className="ri-external-link-line" style={{ fontSize: "16px" }}></i>
                    <span>{disableBtn ? "Opening Stripe..." : "Manage on Stripe"}</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageBankAccount;
